module.exports = __webpack_public_path__ + "d4e583de2dc8750bf23c0986796cc92d.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/head/quarantaene2.jpg
// module id = 778
// module chunks = 0